document.addEventListener('DOMContentLoaded', function() {

    window.clickOutSide = (element, clickOutside, clickInside) => {
      document.addEventListener('click', (event) => {
        if (!element.contains(event.target)) {
          if (typeof clickInside === 'function') {
            clickOutside();
          }
        } else {
          if (typeof clickInside === 'function') {
            clickInside();
          }
        }
      });
    };

    let header = document.querySelector('.header-home'),
        page = document.querySelector('.page'),
        mobileNav = document.querySelector('.mobile-nav');

    //console.log(header);

    window.addEventListener("scroll", function (event) {
      if (header) {
        let scroll = this.scrollY;
        if (scroll !== 0) {
          header.classList.add('header-fixed');
          header.classList.remove('header-transparent');
          //mobileNav.classList.add('fixed');
        } else {
          header.classList.remove('header-fixed');
          header.classList.add('header-transparent');
          //mobileNav.classList.remove('fixed');
        }
      }
    });

    let headerDesktopNavBtn = document.querySelector('.nav-desktop'),
        headerDesktopNav = document.querySelector('.header-nav-desk');

    if (headerDesktopNav) {
      headerDesktopNav.addEventListener('click', e => {
        //e.preventDefault();
        // e.stopPropagation();
        headerDesktopNav.classList.toggle('active');
      });

      window.clickOutSide(
        document.querySelector('.header-nav-desk'), () => {
          headerDesktopNav.classList.remove('active');
        }, () => { return false }
      );
    }


    // headerNavDropdown.forEach(btn => {
    //   btn.addEventListener('click', e => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     dropNav.classList.toggle('active');
    //     page.classList.toggle('fade');
    //   });
    // });

    // window.clickOutSide(
    //   document.querySelector('.dropNav'), () => {
    //     dropNav.classList.remove('active');
    //     page.classList.remove('fade');
    //   }, () => { return false }
    // );

    // headerSearcBtn.addEventListener('click', ()=> {
    //   headerSearcBtn.classList.toggle('active');
    //   headerSearch.classList.toggle('active');
    // });



});
document.addEventListener('DOMContentLoaded', function() {
  (function () {

    //open-close sidebar
    let sidebarOpen = document.getElementById('sidebarOpen'),
        sidebarClose = document.querySelectorAll('.sidebar-close'),
        modalClose = document.querySelectorAll('.modal-close'),
        sidebar = document.querySelectorAll('.sidebar'),
        modal = document.querySelectorAll('.modal'),
        dropBtn = document.querySelectorAll('.sideNav-dropdown'),
        openmodalBtn = document.querySelectorAll('.modal-open'),
        main = document.querySelector('.page'),
        modalNavHead = document.querySelectorAll('.modal-nav-head'),
        modalNavClose = document.querySelector('.modal-nav-head-close');

    // close sidebar on close icon click
    sidebarClose.forEach((el) => {
      el.addEventListener('click', () => {
        el.parentNode.classList.remove('active');
        main.classList.remove('main-fade');
      });
    });

    modalClose.forEach((el) => {
      el.addEventListener('click', () => {
        el.closest("div.modal").classList.remove('active');
        main.classList.remove('main-fade');
      });
    });

    modalNavHead.forEach((el) => {
      el.addEventListener('click', () => {
        el.closest("div.modal").classList.remove('active');
        main.classList.remove('main-fade');
      });
    });

    // close sidebar on main click
    main.addEventListener('click', (e)=> {
      if (main.classList.contains('main-fade')) {
        modal.forEach((el) => {
          el.classList.remove('active');
          main.classList.remove('main-fade');
        });
      }
    });

    // toggle dropdown sidebar nav
    dropBtn.forEach((btn) => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        btn.classList.toggle('active');
      });
    });

    // open sidebar
    openmodalBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        let main = document.querySelector('.page');
        let sidebarId = btn.getAttribute('data-modal');
        let targetSidebar = document.getElementById(`${sidebarId}`);
        setTimeout(() => {
          main.classList.add('main-fade');
        }, 100);
        targetSidebar.classList.add('active');
      });
    });


    // mobile nav
    let modalCatalogOpenBtn = document.querySelector('.modal-open-catalog');
    let nav = document.querySelector('.nav');
    let navBack = document.querySelector('.nav-back');

    modalCatalogOpenBtn.addEventListener('click', (e) => {
      e.preventDefault();
      nav.classList.add('active');
    });

    navBack.addEventListener('click', (e) => {
      e.preventDefault();
      nav.classList.remove('active');
    });

    modalNavClose.addEventListener('click', (e) => {
      e.preventDefault();
      setTimeout(() => {
        nav.classList.remove('active');
      }, 200);
    });

  })();
});

document.addEventListener('DOMContentLoaded', function() {
  (function(){

    let navDropdown = document.querySelectorAll('.nav-menu-dropdown > div'),
        navBtn = document.querySelectorAll('.nav-menu-dropdown > div > span');

    if (navDropdown) {
      navDropdown.forEach((el) => {
        let span = document.createElement('span');
        el.appendChild(span);
        span.addEventListener('click', makeDropdown);
      });
    }

    function makeDropdown(e) {
      e.preventDefault();
      e.target.closest('.nav-menu-dropdown').classList.toggle('active');
    }

  })();
});
document.addEventListener('DOMContentLoaded', function() {

  const swiper = new Swiper(".slider-banner", {
    slidesPerView: "auto",
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      }
    },
  });

  const gridItemSlider = new Swiper(".grid-item-slider", {
    slidesPerView: "auto",
    spaceBetween: 0,
    pagination: false,
    navigation: false
  });

  const reviewSlider = new Swiper(".review-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    pagination: false,
    navigation: {
      nextEl: '.review-slider-next',
      prevEl: '.review-slider-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: "auto",
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 32
      },
    }
  });

  const readmoreSlider = new Swiper(".readmore-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    pagination: false,
    navigation: {
      nextEl: '.readmore-slider-next',
      prevEl: '.readmore-slider-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32
      },
    }
  });

  const videoSlider = new Swiper(".video-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    pagination: false,
    navigation: {
      nextEl: '.video-slider-next',
      prevEl: '.video-slider-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: "auto",
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 32
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32
      }
    }
  });

  const certificateSlider = new Swiper(".certificate-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.certificate-slider-nav-next',
      prevEl: '.certificate-slider-nav-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: "auto",
        spaceBetween: 16
      },
      1024: {
        slidesPerView: "auto",
        spaceBetween: 32
      },
      1280: {
        slidesPerView: "auto",
        spaceBetween: 32,
        centeredSlides: true
      }
    }
  });

  const cardSlider = new Swiper(".card-slider", {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: false,
    navigation: {
      nextEl: '.card-slider-next',
      prevEl: '.card-slider-prev',
    },
  });

});

document.addEventListener('DOMContentLoaded', function() {

  const videos = document.querySelectorAll('.section-video video');
  let currentlyPlaying = null;

  if (videos) {

    videos.forEach(video => {
      // Play/pause handler
      video.addEventListener('play', function() {
        pauseOtherVideos(this);
      });

      // Click handler for better UX
      video.addEventListener('click', function() {
        if (this.paused) {
          this.play();
        } else {
          this.pause();
        }
      });

      // Keyboard accessibility
      video.addEventListener('keydown', function(e) {
        if (e.code === 'Space' || e.key === 'Enter') {
          e.preventDefault();
          if (this.paused) {
            this.play();
          } else {
            this.pause();
          }
        }
      });
    });

    function pauseOtherVideos(currentVideo) {
      videos.forEach(video => {
        if (video !== currentVideo && !video.paused) {
          video.pause();
          // Optional: Reset playback to start
          // video.currentTime = 0;
        }
      });
      currentlyPlaying = currentVideo;
    }

    // Pause all videos when window loses focus
    window.addEventListener('blur', function() {
      if (currentlyPlaying) {
        currentlyPlaying.pause();
      }
    });

  }

  // Video Slider home page
  let videoItem = document.querySelectorAll('.section-video .video');
  if (videoItem) {
    videoItem.forEach((el) => {
      el.addEventListener('click', (event) => {
        let overlay = event.currentTarget.querySelector('.video-overlay'),
            video = event.currentTarget.querySelector('video');
        overlay.classList.add('hidden');
        video.volume = 0.2;
        video.play();
      });
    });
  }

  // Video Tabs home page
  let button = document.querySelectorAll('.video-tab-btn'),
      tab = document.querySelectorAll('.video-tab-item'),
      videoStream = document.querySelectorAll('.video-stream'),
      i;

  // desktop tabs
  button.forEach( (btn) => {
    btn.addEventListener('click', () => {
      let tabId = btn.getAttribute('data-tab');
      for( i = 0; i < button.length; i++ ) {
        button[i].classList.remove('active');
      }
      for( i = 0; i < tab.length; i++ ) {
        tab[i].classList.remove('active');
      }
      btn.classList.add('active');
      document.getElementById('videotab' + tabId).classList.add('active');
      videoStream.forEach((video) => {
        setTimeout(() => {
          video.pause();
        }, 100);
      });
    });
  });

  // show ref for section-video-solo on main page
  //let videoSolo = document.getElementById('video-solo');
  let videoSoloMobile = document.getElementById('video-solo-mobile');
  let videoSoloDesktop = document.getElementById('video-solo-desktop');
  let videoSoloRefs = document.querySelector('.ref');
  let posterVideoEndMobile = document.querySelector('.poster-video-end-mobile');
  let posterVideoEndDesktop = document.querySelector('.poster-video-end-desktop');

  // if (videoSoloRefs) {
  //   videoSolo.addEventListener('ended', e => {
  //     videoSoloRefs.classList.add('active');
  //     posterVideoEndMobile.classList.add('active');
  //     //video.style.display = "none";
  //   });
  // }

  if (videoSoloRefs) {
    videoSoloMobile.addEventListener('ended', e => {
      videoSoloRefs.classList.add('active');
      posterVideoEndMobile.classList.add('active');
      //video.style.display = "none";
    });
  }

  if (videoSoloRefs) {
    videoSoloDesktop.addEventListener('ended', e => {
      videoSoloRefs.classList.add('active');
      posterVideoEndDesktop.classList.add('active');
      //video.style.display = "none";
    });
  }

});
document.addEventListener('DOMContentLoaded', function() {
  let accordionBtn = document.querySelectorAll('.accordion-btn');
  let i;

  if (accordionBtn) {
    for (i = 0; i < accordionBtn.length; i++) {
      accordionBtn[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle("active");

        /* Toggle between hiding and showing the active panel */
        let panel = this.nextElementSibling;
        if (panel.classList.contains('hidden')) {
          panel.classList.remove('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });
    }
  }

});
document.addEventListener('DOMContentLoaded', function() {
  (function () {
    let scrollbar = document.querySelector('.scrollbarCustom');
    let imageboxScroll = document.querySelector('.imageboxScroll');

    if (imageboxScroll) {
      new SimpleBar(imageboxScroll,
        {
          autoHide: false,
          forceVisible: true
        }
      );
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('.scrollbarCustom'),
      (el) => new SimpleBar(el,
        {
          autoHide: false,
          forceVisible: true
        }
      )
    );

  })();
});
document.addEventListener('DOMContentLoaded', function() {

  gsap.registerPlugin(ScrollTrigger);

    // if (window.innerWidth > 1200) {

      // create the scrollSmoother before your scrollTriggers
      // ScrollSmoother.create({
      //   smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
      //   effects: true, // looks for data-speed and data-lag attributes on elements
      //   smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
      // });

      let introHome = document.querySelector('.intro-home');
      let logoIntro = document.querySelector('.intro-home-logo');
      let headerLogo = document.querySelector('.header-logo-animate');

      if (introHome) {

        gsap.set(".intro-home-logo", { y: 0, ease: "power1.out" });
        gsap.set(".intro-home-text", { y: 0, ease: "power1.out" });
        gsap.set(".header-logo-animate", { opacity: 0, ease: "power1.out" });

        let tl = gsap
          .timeline({
            scrollTrigger: {
              trigger: ".intro-home",
              start: "top",
              scrub: true,
              //pin: true,
              end: "500",
              //markers: true
            }
          })
          .to(".intro-home-logo", { y: '-50vh', scale: '0' }, 0)
          .to(".intro-home-text", { y: '-50vh', scale: '0.3' }, 0)
          .to(".header-logo-animate", { opacity: 1 });
      }

});
document.addEventListener('DOMContentLoaded', function () {
  (function () {
    let selectList = document.querySelector('.select-list'),
        select = document.querySelector('.select-input'),
        input = document.getElementById('selectInput'),
        options = document.querySelectorAll('.select-list .select-item'),
        selectCity = document.querySelectorAll('.select-city'),
        selectCategory = document.querySelectorAll('.select-category');


    window.clickOutSide = (element, clickOutside, clickInside) => {
      document.addEventListener('click', (event) => {
        if (!element.contains(event.target)) {
          if (typeof clickInside === 'function') {
            clickOutside();
          }
        } else {
          if (typeof clickInside === 'function') {
            clickInside();
          }
        }
      });
    };

    if (document.querySelector('.prod-select')) {
      window.clickOutSide(
        document.querySelector('.prod-select'), () => {
          selectList.classList.remove('active');
        }, () => { return false }
      );
    }

    if (select) {
      select.onclick = () => {
        selectList.classList.toggle('active');
      };
    }

    options.forEach((e) => {
      e.addEventListener('click', () => {
        input.value = e.innerText;
        selectList.classList.remove('active');
        options.forEach((e) => {
          e.classList.remove('selected');
        });
        e.classList.add('selected');
      });
    });

    selectCity.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        let city = el.getAttribute('data-city');
        let location = document.querySelectorAll('.location');
        location.forEach((el) => {
          el.innerText = city;
        });
      });
    });

    selectCategory.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        let data = el.getAttribute('data-category');
        console.log(data)
        let location = document.querySelector('.blog-category');
        location.innerText = data;
      });
    });

  })();
});
document.addEventListener('DOMContentLoaded', function () {

  let btnDuplicate = document.getElementById('btn-duplicate');
  let btnRemove = document.getElementById('btn-remove');
  let rowID = 0;

  function duplicateRow() {
    const originalSection = document.getElementById('extend-row-1');
    const duplicatedSection = originalSection.cloneNode(true);

    // Optional: Modify the ID and name attributes to avoid conflicts
    const newId = 'extend-row-' + rowID++; // Unique ID
    duplicatedSection.id = newId;

    // Update name attributes of form elements within the duplicated section
    const inputs = duplicatedSection.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      if (input.name) {
        input.name = input.name.replace('pet-age', 'pet-age-' + rowID);
        input.name = input.name.replace('pet-type', 'pet-type-' + rowID);
        input.name = input.name.replace('pet-name', 'pet-name-' + rowID);
      }
    });

    const parentContainer = document.getElementById('target-extend');
    parentContainer.appendChild(duplicatedSection);
  }


  function removeLastRow() {
    const container = document.getElementById('target-extend');
    const lastElement = container.lastElementChild;

    if (lastElement) {
        container.removeChild(lastElement);
    } else {
        console.log("No more children to remove.");
    }
  }


  if (btnDuplicate) {
    btnDuplicate.addEventListener('click', (e) => {
      duplicateRow();
      if (rowID > 0) {
        btnRemove.classList.remove('hidden');
      }
    });
  }

  if (btnRemove) {
    btnRemove.addEventListener('click', (e) => {
      removeLastRow();
      rowID--;
      if (rowID < 1) {
        btnRemove.classList.add('hidden');
      }
    });
  }


  // show extend form block
  let btnExtendToggle = document.querySelector('.btn-extend');
  let formExtendBlock = document.querySelector('.form-extend');
  if (btnExtendToggle) {
    btnExtendToggle.addEventListener('click', (e) => {
      e.target.classList.toggle('active');
      formExtendBlock.classList.toggle('active');
    });
  }

});
document.addEventListener('DOMContentLoaded', function() {

  const sliderTeam = document.querySelector('.slider-team');

  if (sliderTeam) {

    gsap.registerPlugin(ScrollTrigger);

    gsap.set(".slider-team .slider-team-item:nth-child(2)", { y: '100%', ease: "power1.out" });
    gsap.set(".slider-team .slider-team-item:nth-child(3)", { y: '100%', ease: "power1.out" });

    let tl = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".team-info",
          start: "top 200px",
          scrub: true,
          pin: true,
          end: "+=800"
          //markers: true
        }
      })
      .to(".slider-team .slider-team-item:nth-child(2)", { y: '0%' })
      .to(".slider-team .slider-team-item:nth-child(3)", { y: '0%' });
  }

});

document.addEventListener('DOMContentLoaded', function() {

  let clock = document.querySelector('.clock');

  if (clock) {
    function setClock() {
      const now = new Date();
      const seconds = now.getSeconds();
      const minutes = now.getMinutes();
      const hours = now.getHours();

      // Calculate degrees for each hand
      const secondDeg = seconds * 6;
      const minuteDeg = minutes * 6 + seconds * (360/3600);
      const hourDeg = hours * 30 + minutes * (360/720);

      document.querySelector(".hand-second").style.transform = `rotate(${secondDeg}deg)`;
      document.querySelector(".hand-minute").style.transform = `rotate(${minuteDeg}deg)`;
      document.querySelector(".hand-hour").style.transform = `rotate(${hourDeg}deg)`;
    }

    // Initial call to set the clock when the page loads
    setClock();

    // Update the clock every second
    setInterval(setClock, 1000);
  }

});

document.addEventListener('DOMContentLoaded', function() {
  (function(){

    let button = document.querySelectorAll('.tab-btn'),
        tab = document.querySelectorAll('.tab-item'),
        teamTabs = document.querySelector('.team-tabs-content'),
        i;

    if (teamTabs) {
      // desktop tabs
      button[0].classList.add('active');
      tab[0].classList.add('active');
      button.forEach( (btn) => {
        btn.addEventListener('click', () => {

          let tabId = btn.getAttribute('data-tab');
          for( i = 0; i < button.length; i++ ) {
            button[i].classList.remove('active');
          }
          for( i = 0; i < tab.length; i++ ) {
            //tab[i].style.display = 'none';
            tab[i].classList.remove('active');
          }
          btn.classList.add('active');
          //document.getElementById('tab' + tabId).style.display = 'block';
          document.getElementById('tab' + tabId).classList.add('active');

        });
      });
    }

  })();

});
// Проверяем, было ли уже показано уведомление
function shouldShowCookieModal() {
  return !localStorage.getItem('cookieAccepted');
}

// Сохраняем информацию о принятии cookie
function acceptCookies() {
  console.log('create cookie');
  localStorage.setItem('cookieAccepted', 'true');
}

// Показываем модальное окно
function showCookieModal() {
  const modal = document.getElementById('cookieModal');
  if (modal) {
    modal.style.display = 'block';
  }
}

// Скрываем модальное окно
function hideCookieModal() {
  const modal = document.getElementById('cookieModal');
  modal.style.display = 'none';
}

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
  const closeBtn = document.querySelectorAll('.cookie-close-btn');
  const modal = document.getElementById('cookieModal');

  // Показываем модальное окно только при первом посещении
  if (shouldShowCookieModal()) {
    showCookieModal();
  }

  // Обработчик для кнопки закрытия
  if (closeBtn) {
    closeBtn.forEach((item) => {
      item.addEventListener('click', function() {
        acceptCookies();
        hideCookieModal();
      });
    });
  }

  // Закрытие при клике вне модального окна
  if (modal) {
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        acceptCookies();
        hideCookieModal();
      }
    });
  }

});
document.addEventListener('DOMContentLoaded', function() {
  const scrollToTopBtn = document.getElementById('scrollToTop');

  // Показываем/скрываем кнопку при прокрутке
  if (scrollToTopBtn) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        scrollToTopBtn.classList.add('visible');
      } else {
        scrollToTopBtn.classList.remove('visible');
      }
    });

    // Прокрутка наверх при клике
    scrollToTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

});
document.addEventListener('DOMContentLoaded', function() {
  (function(){

    let priceList = document.querySelectorAll('.price-list-wrap');

    if (priceList) {
      priceList.forEach((item) => {
        let row = item.querySelectorAll('.price-list-row');
        row.length == 1 ? row[0].classList.add('price-list-row-sole') : null;
      });
    }

  })();

});


//// =include ./project/video.stream.js
